<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14.9722 11.2619C15.6687 11.8588 15.2465 13 14.3293 13C14.1155 13 13.9075 12.9307 13.7365 12.8024L10 9.99998L6.26345 12.8024C6.09244 12.9306 5.88445 13 5.67069 13C4.75347 13 4.33133 11.8588 5.02773 11.2619L9.99998 7L14.9722 11.2619Z"
    fill="currentColor"
  />
</svg>
